import NetworkLogic from "../../Shared/NetworkLogic";
import RemoteSprite from "../../Common/RemoteSprite";
import Player from "../../Models/Player";
import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ZhiShuDetails extends cc.Component {
    @property(RemoteSprite)
    rspHead:RemoteSprite = null;
    @property(cc.Label)
    soubUserId: cc.Label = null;//id
    @property(cc.Label)
    registerDate: cc.Label = null;// 注册时间
    @property(cc.Label)
    todayValidBetNumber: cc.Label = null;//今日有效投注
    @property(cc.Label)
    todayTotalValidBetNumber: cc.Label = null;//总有效投注
    @property(cc.Label)
    teamTotalNumber: cc.Label = null;//团队人数
    @property(cc.Label)
    todayTeamValidBetNumber: cc.Label = null;//今日团队有效投注
    @property(cc.Label)
    subordinateReturnNumber: cc.Label = null;//直属人数
    @property(cc.Label)
    yesterdayReturnMoney: cc.Label = null;//昨日佣金
    @property(cc.Label)
    historyReturnMoney: cc.Label = null;//历史总佣金
    @property(cc.Label)
    extractReturnMoney: cc.Label = null;//可提取佣金
    onLoad () {
        this.node.on("ZSDETAIL",this.updateUI.bind(this))
        Player.getPy("head") && (this.rspHead.url = Player.getPy("head"));

    }
    /**
     * imageUrl: ""
     soubUserId: ""
     registerDate: "2020-01-09 18:03:32"
     todayValidBetNumber: 0
     todayTotalValidBetNumber: 824800
     teamTotalNumber: 7
     subordinateReturnNumber: 2
     newTeamTotalNumber: 0
     newSubordinateReturnNumber: 0
     todayTeamValidBetNumber: 0
     yesterdayReturnMoney: 0
     historyReturnMoney: 0
     extractReturnMoney: 0
     * @param event
     * @param param
     */
    updateUI(data,id){
        this.soubUserId.string = id;
        this.registerDate.string = data.registerDate;
        this.todayValidBetNumber.string = data.todayValidBetNumber;
        this.todayTotalValidBetNumber.string = data.todayTotalValidBetNumber;
        this.todayTeamValidBetNumber.string = data.todayTeamValidBetNumber;
        this.teamTotalNumber.string = data.teamTotalNumber + "("  + data.newTeamTotalNumber + ")";
        this.subordinateReturnNumber.string = data.subordinateReturnNumber + "("  + data.newSubordinateReturnNumber + ")";
        this.yesterdayReturnMoney.string = data.yesterdayReturnMoney;
        this.historyReturnMoney.string = data.historyReturnMoney;
        this.extractReturnMoney.string = data.extractReturnMoney;
    }

    protected onDestroy(): void {
        this.node.off("ZSDETAIL");
    }
    onBtnClick(){
        AudioManager.playSound("close");
        this.node.active  = false;
    }
}
